import { Field, useFormikContext } from "formik"
import { FieldItemProps, FieldType, RSVPFormFields, RSVPFormValues } from "../types"
import { SelectField } from "src/sections/capterra/ContactForm"
import Checkbox from "src/components/Form/CustomFields/Checkbox";

const FieldItem = ({ 
    label,
    type = "text", 
    name, 
    placeholder = "", 
    required = false,
    options = []
}: FieldItemProps) => {
    const form = useFormikContext<RSVPFormValues>();

    const classNameField = `login-form__inputfield
        ${
            form?.errors?.[name] && 
            form?.touched?.[name] && 
            'login-form__inputfield--error'
        }
    `
  switch (type) {
    case "text":
      return (
        <Field
          type='text'
          className={classNameField}
          name={name}
          placeholder={placeholder}
          autoComplete='off'
        />
      )
    case "select":
      return (
        <Field 
            name={name} 
            placeholder={label} 
            component={SelectField} 
            required={required} 
            options={options} 
        />
      )
    case "multiple":
      return (
        <Field 
            name={name} 
            placeholder={label} 
            component={SelectField} 
            required={required} 
            options={options} 
            isMulti
        />
      )
    case "checkbox":
      return (
        <Field 
            name={name} 
            placeholder={label} 
            component={Checkbox} 
            required={required} 
            options={options}
        />
      )
    default:
      return null
  }
}

export default FieldItem
